// Table header configuration for the ADMT archive page (/admt).
// Static (no per-user persistence) since this is read-only archive data,
// but mirrors the shape of useTableConfiguration so TableComponent can be
// reused unchanged.

// All available fields on ADMT_archive.admt_reportsearch_flat
const availableFields = [
  { key: "report_id", label: "Report id", type: "standard" },
  { key: "report_type", label: "Report type", type: "standard" },
  { key: "date_of_visit", label: "Date of visit", type: "standard" },
  { key: "part_number", label: "Part number", type: "standard" },
  { key: "description", label: "Description", type: "standard" },
  { key: "failure_reason", label: "Failure reason", type: "standard" },
  { key: "serial_number", label: "Serial number", type: "standard" },
  { key: "site_name", label: "Site name", type: "standard" },
  { key: "rig_id", label: "Rig ID", type: "standard" },
  { key: "rig_model", label: "Rig model", type: "standard" },
  { key: "customer_entity", label: "Customer account number", type: "standard" },
  { key: "country_name", label: "Country", type: "standard" },
  { key: "customer_name", label: "Customer name", type: "standard" },
  { key: "sales_area", label: "Sales area", type: "standard" },
  { key: "entity", label: "Entity", type: "standard" },
  { key: "region_name", label: "Region", type: "standard" },
  { key: "product_line", label: "Product line", type: "standard" },
  { key: "generated_by", label: "Generated by", type: "standard" },
  { key: "report_as", label: "Int. / ext.", type: "standard" },
  { key: "delivery_sequence_text", label: "Delivery sequence", type: "standard" },
  { key: "blob_updated_at", label: "Archived at", type: "standard" },
  { key: "blob_url", label: "Document link", type: "standard" },
];

function getDefaultWidth(fieldKey) {
  const widths = {
    report_id: 120,
    report_type: 80,
    date_of_visit: 100,
    customer_name: 120,
    country_name: 100,
    site_name: 120,
    description: 220,
    serial_number: 120,
    failure_reason: 190,
    part_number: 120,
    rig_model: 110,
    rig_id: 110,
    customer_entity: 150,
    sales_area: 100,
    entity: 100,
    region_name: 100,
    product_line: 100,
    generated_by: 150,
    report_as: 100,
    delivery_sequence_text: 150,
    blob_updated_at: 140,
    blob_url: 100,
  };
  return widths[fieldKey] || 110;
}

function buildFields(visibleKeys) {
  return availableFields.map((field, index) => ({
    ...field,
    visible: visibleKeys.includes(field.key),
    order: index + 1,
    width: getDefaultWidth(field.key),
  }));
}

// ADMT archive only ever contains RTC / CVR / SA report types
const configurations = [
  {
    id: "admt_rtc",
    name: "Rock tool cards (RTC)",
    reportType: "RTC",
    isDefault: true,
    fields: buildFields([
      "date_of_visit",
      "customer_name",
      "country_name",
      "site_name",
      "description",
      "serial_number",
      "failure_reason",
      "part_number",
      "sales_area",
      "product_line",
      "report_as",
    ]),
  },
  {
    id: "admt_cvr",
    name: "Customer visit reports (CVR)",
    reportType: "CVR",
    isDefault: true,
    fields: buildFields([
      "date_of_visit",
      "customer_name",
      "site_name",
      "failure_reason",
      "sales_area",
      "entity",
      "product_line",
      "generated_by",
      "report_as",
    ]),
  },
  {
    id: "admt_sa",
    name: "Site audits (SA)",
    reportType: "SA",
    isDefault: true,
    fields: buildFields([
      "date_of_visit",
      "customer_name",
      "site_name",
      "sales_area",
      "entity",
      "product_line",
      "generated_by",
      "report_as",
    ]),
  },
];

const configMapping = {
  RTC: "admt_rtc",
  CVR: "admt_cvr",
  SA: "admt_sa",
};

const useAdmtTableConfiguration = () => {
  const getConfigurationForReportType = (reportTypeKey) => {
    const configId = configMapping[reportTypeKey] || "admt_rtc";
    return configurations.find((c) => c.id === configId) || configurations[0];
  };

  const getTableHeaders = (reportTypeKey) => {
    const config = getConfigurationForReportType(reportTypeKey);
    if (!config || !config.fields) return [];

    const visibleFields = config.fields
      .filter((field) => field.visible)
      .sort((a, b) => (a.order || 0) - (b.order || 0));

    const headers = visibleFields.map((field) => ({
      key: field.key,
      label: field.label,
      width: field.width || getDefaultWidth(field.key),
      sortable: field.key !== "actions",
    }));

    headers.push({
      key: "actions",
      label: "Actions",
      width: 110,
      sortable: false,
    });

    return headers;
  };

  return {
    configurations,
    loading: false,
    getConfigurationForReportType,
    getTableHeaders,
  };
};

export default useAdmtTableConfiguration;
